/* eslint-disable prefer-const */
import { get } from "lodash";
import { array, bool, func, number, object, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDeviceType } from "../customHooks/useDeviceType";
import { addDatalayerEventStory } from "../utils";
import { LiveBlogStory, PhotoStory, SponsoredStory, TextStory, VideoStory, CreatorStory } from "./index";
import { modifyStory } from "./modify-story";

function StoryWrapper({
  isATGlobal,
  story,
  config,
  initAccessType,
  checkAccess,
  recommendedStories,
  params,
  magazineDetails,
  moreVideos,
  disablePageAnalytics = false,
  continueReading = null,
  index = 0,
}) {
  const [hasAccess, setHasAccess] = useState(true);
  const storyTemplate = story["story-template"];
  const isDesktop = useDeviceType() === "desktop";
  const member = useSelector((state) => get(state, ["member"], null));

  const adWidget = () => {
    return <></>;
  };

  useEffect(() => {
    // The below block is commented intentionally as in the function execution, the function used wretch instead of fetch, if this has to work implement using fetch
    // loadRelatedStories(story, config).then((relatedStories) => setRelatedStories(relatedStories));
  }, []);

  useEffect(() => {
    if (typeof initAccessType !== "function" || typeof checkAccess !== "function") return;

    initAccessType(() => {
      checkAccess(story.id).then((res) => {
        const { granted } = res[story.id];
        setHasAccess(granted);
      });
    });
  }, [isATGlobal]);

  useEffect(() => {
    if (!disablePageAnalytics) {
      story && addDatalayerEventStory(story, null, null, false);
    }
  }, [disablePageAnalytics, story]);

  useEffect(() => {
    if (member) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "dl_user_info",
        login_status: "logged-in",
        user_id: `${member.id}`,
        subscription_status: "not-subscribed",
      });
    }
  }, [member, story]);
  const modifiedStory = modifyStory(story, isDesktop, member);

  // Can switch to a different template based story-template, or only show a spoiler if index > 0

  const returnStoryTemplate = (storyTemplate) => {
    switch (storyTemplate) {
      case "text":
      case "magazine":
        return (
          <TextStory
            story={modifiedStory}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
            recommendedStories={recommendedStories}
            magazineDetails={magazineDetails}
            continueReading={continueReading}
            hideBreadcrumb={index > 0}
            isPerpetualStory={index > 0}
          />
        );
      case "video":
        return (
          <VideoStory
            story={story}
            moreVideos={moreVideos}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
          />
        );
      case "photo":
        return (
          <PhotoStory
            story={story}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
            recommendedStories={recommendedStories}
          />
        );
      case "live-blog":
        return (
          <LiveBlogStory
            story={story}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
            recommendedStories={recommendedStories}
            params={params}
          />
        );
      case "sponsored":
        return <SponsoredStory story={modifiedStory} recommendedStories={recommendedStories} />;
      case "creator":
        return (
          <CreatorStory
            story={modifiedStory}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
            recommendedStories={recommendedStories}
            magazineDetails={magazineDetails}
            continueReading={continueReading}
          />
        );
      default:
        return (
          <TextStory
            story={modifiedStory}
            config={{ ...config }}
            adWidget={adWidget}
            adPlaceholder={<></>}
            hasAccess={hasAccess}
            recommendedStories={recommendedStories}
            magazineDetails={magazineDetails}
            hideBreadcrumb={index > 0}
          />
        );
    }
  };

  return <>{returnStoryTemplate(storyTemplate)}</>;
}

StoryWrapper.propTypes = {
  isATGlobal: bool,
  story: object,
  config: object,
  initAccessType: func,
  checkAccess: func,
  recommendedStories: array,
  params: string,
  magazineDetails: object,
  moreVideos: object,
  disablePageAnalytics: bool,
  continueReading: object,
  index: number,
};

export default React.memo(StoryWrapper);
